module.exports = __webpack_public_path__ + "2bb397cdad23f404be9fc18c70c6840f.js";